import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TestimonialList from './testimonial_list';
import TestimonialDetail from './testimonial_detail';

class Testimonial extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <TestimonialList/>;
    }else{
      if(params.id===undefined){
        view = <TestimonialDetail/>;
      }else{
        view = <TestimonialDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Testimonial.contextTypes = {
  router: PropTypes.object
};

export default Testimonial;
